import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import classNames from 'classnames';

import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import MODULE_MANAGEMENT_SIDEBAR_DATA from 'data/moduleManagementSidebarData';
import NavBar from 'components/NavBar';
import styles from './ModuleManagementSidebar.module.scss';
import WithPermissions from 'components/WithPermissions';

export default function ModuleManagementSidebar() {
  return (
    <>
      <NavBar
        title="MODULE MANAGEMENT TOOL"
        className="p-xs"
        id="module-management-sidebar"
      />
      <ElementSpacePlaceholder elementId="module-management-sidebar" />
      <div className={styles.root}>
        {MODULE_MANAGEMENT_SIDEBAR_DATA.map((data, sectionIndex) => (
          <div
            className={styles.section}
            key={`module-management-sidebar-${sectionIndex}`}
          >
            <div
              className={classNames('bold', 'dark', styles.header)}
              key={sectionIndex}
            >
              {data.header}
            </div>
            <div className={styles.tabs}>
              {data.tabs.map((tab, tabIndex) => (
                <WithPermissions
                  key={`module-management-tabs-${tabIndex}`}
                  subject={tab.subject}
                  permissions={tab.permissions}
                >
                  <NavLink
                    to={tab.to}
                    tabIndex={tabIndex}
                    className={({ isActive }) =>
                      classNames(styles.tab, { [styles.tabActive]: isActive })
                    }
                  >
                    {tab.tabName}
                  </NavLink>
                </WithPermissions>
              ))}
            </div>
          </div>
        ))}
      </div>
      <div className={styles.page}>
        <Outlet />
      </div>
    </>
  );
}
